const Notifications = () => import('@/modules/notifications/index.vue');
import checkPermissions from '@/modules/notification/_routes/checkPermissions';

export default [
  {
    path: '/notificacoes',
    name: 'notifications',
    component: Notifications,
    props: true,
    meta: {
      isAvaliableInMenu: true,
      navbarTitle: 'Notificações',
      menuData: {
        title: 'Notificações',
        id: 'noticationsSidebar',
        section: 'Comunicação',
        icon: 'notification',
      },
    },
    beforeEnter: (to, from, next,) => checkPermissions(next, 'READ_NOTIFICATION', 'root',),
  },
];
